import React, {FC} from 'react';

/** 구독 구매 약관 한국어 본문（구조는 content/en 및 content/zh와 1:1 대응. 2026-09-17 AI 번역, 법률 문구는 비즈니스 검토 대기） */
const KoContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">시행일: August 28, 2026</p>
      <p className="v3-doc-meta">최종 업데이트: August 28, 2026</p>
      <p>Xiangji(이하 "Xiangji")가 제공하는 구독 서비스에 오신 것을 환영합니다!</p>
      <p>
        Xiangji는 이미지 번역, 이미지 편집, 상품 이미지 생성, 상품 상세 이미지 세트 생성, 상품 메인 및 서브 이미지
        생성을 포함하되 이에 국한되지 않는 기타 AI 시각 콘텐츠 제작 관련 유료 부가 서비스(이하 "구독 서비스")를
        제공합니다.
      </p>
      <p>
        Xiangji의 구독 서비스를 이용하려면 Xiangji가 공지한 요금 기준에 따라 해당 구독 플랜을 구매하셔야 합니다. 구독
        서비스를 구매하고 이용하기 전에 본 「Xiangji 구독 약관」(이하 "본 약관")의 전체 내용을 충분히 읽고 이해해 주시기
        바랍니다.
      </p>
      <p>
        <strong>
          Xiangji는 면책 또는 책임 제한, 이용자 권리 제한, 서비스 변경, 환불, 계정 관리, 자동 갱신, 법적 책임 및 분쟁
          해결과 관련된 본 약관의 조항을 특히 유의하여 읽어 주시기를 요청드립니다. 위 조항은 귀하의 중대한 권익과 관련될
          수 있으므로, 구독 서비스를 구매하기 전에 반드시 신중히 읽어 주시기 바랍니다.
        </strong>
      </p>
      <p>
        본 약관의 일부 또는 전부에 동의하지 않으시는 경우, Xiangji의 구독 서비스를 구매하거나 이용하지 마시기 바랍니다.
        "지금 구매", "구매 확인", "동의 후 결제" 또는 기타 유사한 버튼을 클릭하거나, 결제를 완료하거나 구독 서비스
        이용을 시작하는 경우, 본 약관의 모든 조항을 충분히 읽고 이해했으며 그 구속력에 동의한 것으로 간주됩니다.
      </p>
      <p>
        만 18세 미만인 경우, 법정 대리인과 함께 본 약관을 읽고 확인하시기 바라며, 법정 대리인의 동의를 얻은 후에 구독
        서비스를 구매하고 이용하시기 바랍니다.
      </p>
      <section>
        <h2>1. 약관의 정의 및 설명</h2>
        <ol>
          <li>
            <strong>Xiangji</strong>
            <p>
              "Xiangji"란 <strong>[쑤저우 Xiangji 테크놀로지 서비스 유한공사]</strong> 및 이가 운영하는 Xiangji
              웹사이트, 웹 애플리케이션, 클라이언트, 브라우저 확장 프로그램 및 기타 관련 제품과 서비스를 의미합니다.
            </p>
            <p>Xiangji 공식 웹사이트는 다음과 같습니다:</p>
            <p>
              <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
                <strong>https://www.xiangjifanyi.com/</strong>
              </a>
            </p>
            <p>
              구체적인 서비스 입구 및 실제 서비스를 제공하는 플랫폼은 Xiangji 공식 페이지에 공지된 정보를 기준으로
              합니다.
            </p>
          </li>
          <li>
            <strong>이용자</strong>
            <p>
              이용자란 Xiangji 계정에 등록 및 로그인하여 Xiangji의 구독 서비스를 구매하거나 이용하는 자연인, 법인 또는
              비법인 단체를 의미합니다.
            </p>
            <p>본 약관에서 "귀하"와 "이용자"는 모두 구독 서비스의 구매자 및 실제 이용자를 의미합니다.</p>
          </li>
          <li>
            <strong>구독 서비스</strong>
            <p>
              구독 서비스란 이용자가 구매한 특정 구독 플랜에 따라 Xiangji가 약정된 구독 기간 내에 이용자에게 제공하는 AI
              시각 콘텐츠 제작 및 관련 부가 서비스를 의미합니다.
            </p>
            <p>구체적인 서비스 내용은 다음을 포함하되 이에 국한되지 않을 수 있습니다:</p>
            <ul>
              <li>상품 이미지 번역;</li>
              <li>상품 이미지 편집;</li>
              <li>상품 이미지 생성;</li>
              <li>상품 장면 이미지 생성;</li>
              <li>상품 모델 이미지 생성;</li>
              <li>상품 메인 및 서브 이미지 생성;</li>
              <li>상품 상세 이미지 세트 생성;</li>
              <li>상품 상세 페이지, A+ 페이지 등 콘텐츠 생성;</li>
              <li>영상 및 기타 시각 콘텐츠 처리;</li>
              <li>Xiangji가 수시로 출시하는 기타 AI 시각 콘텐츠 서비스.</li>
            </ul>
            <p>
              <strong>
                구체적인 서비스 내용, 플랜 혜택, 사용 횟수, 크레딧, 유효 기간, 처리 사양 및 기타 서비스 규칙은 구매 시
                해당 페이지에 실제 표시되는 내용을 기준으로 합니다.
              </strong>
            </p>
          </li>
          <li>
            <strong>구독 플랜</strong>
            <p>
              구독 플랜이란 Xiangji가 다양한 이용자 요구에 따라 제공하는 다양한 서비스 조합으로, 월간 구독, 분기 구독,
              연간 구독 및 기타 주기적 구독 상품을 포함하되 이에 국한되지 않습니다.
            </p>
            <p>
              구독 플랜에 따라 가격, 서비스 내용, 사용 크레딧 및 혜택이 다를 수 있습니다. 자세한 사항은 구매 페이지에
              표시된 내용을 기준으로 합니다.
            </p>
          </li>
          <li>
            <strong>구독 기간</strong>
            <p>구독 기간이란 이용자가 구독 플랜을 구매한 후 해당 구독 혜택을 누릴 수 있는 유효 기간을 의미합니다.</p>
            <p>
              구독 기간은 월간, 분기, 연간 또는 Xiangji가 제공하는 기타 기간일 수 있습니다. 자세한 사항은 구매 페이지의
              표시를 기준으로 합니다.
            </p>
          </li>
          <li>
            <strong>구독 혜택</strong>
            <p>
              구독 혜택이란 이용자가 구독 기간 내에 구매한 플랜에 따라 획득하는 서비스 크레딧, 기능 권한 및 기타 혜택을
              의미합니다.
            </p>
            <p>
              <strong>
                플랜에 따라 대응되는 구독 혜택은 다를 수 있습니다. 자세한 사항은 구매 페이지 및 Xiangji가 공식적으로
                공지하는 규칙을 기준으로 합니다.
              </strong>
            </p>
          </li>
          <li>
            <strong>본 약관</strong>
            <p>
              본 약관은 Xiangji 이용자 서비스 약관, 개인정보 처리방침, AI 관련 서비스 약관 및 기타 관련 서비스 규칙의
              중요한 구성 부분입니다.
            </p>
            <p>본 약관은 위 각 약관과 함께 Xiangji와 이용자 간의 구독 서비스에 관한 완전한 합의를 구성합니다.</p>
            <p>
              본 약관과 기타 약관 간에 구독 서비스와 관련하여 불일치가 있는 경우, 구독 서비스에 관한 본 약관의 규정이
              우선 적용되며, 기타 사항은 계속 관련 약관에 따릅니다.
            </p>
          </li>
          <li>
            <strong>서비스 규칙</strong>
            <p>
              본 약관의 내용에는 Xiangji가 사업 발전 필요에 따라 게시하는 관련 공지, 페이지 설명, 제품 규칙, 과금 규칙,
              도움말 문서 및 기타 서비스 규범도 포함됩니다.
            </p>
            <p>
              위 내용은 공식 게시 즉시 본 약관의 불가분의 구성 부분을 이루며, 본 약관과 동일한 법적 효력을 갖습니다.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>2. 구독 서비스의 구매 및 이용</h2>
        <ol>
          <li>계정 및 구매</li>
        </ol>
        <p>1.1 구독 서비스를 구매하기 전에 Xiangji 계정에 등록 또는 로그인하셔야 합니다.</p>
        <p>Xiangji 플랫폼에서 사용하는 계정은 Xiangji가 귀하의 신원을 확인하고 구독 혜택을 제공하는 주요 근거입니다.</p>
        <p>
          1.2 귀하는 자신의 계정, 비밀번호 및 관련 계정 정보를 적절히 보관해야 하며, 귀하의 계정을 통해 수행된 조작에
          대해 그에 상응하는 책임을 부담합니다.
        </p>
        <p>
          <strong>
            Xiangji의 서면 허가 없이, 귀하는 임대, 대여, 양도, 공유, 판매 또는 기타 방식으로 제3자에게 계정 사용권을
            제공할 수 없습니다.
          </strong>
        </p>
        <p>
          Xiangji는 비정상 로그인, 대량 공유, 악의적 이용 또는 플랫폼의 정상 운영에 영향을 미치는 기타 상황을 발견한
          경우, 로그인 제한, 기능 제한, 서비스 중단 또는 기타 합리적인 조치를 취할 권리가 있습니다.
        </p>
        <p>
          1.3 제3자 계정을 통해 Xiangji에 로그인하는 경우, 해당 제3자 계정이 실재하고 합법적이며 유효함을 보장해야
          합니다.
        </p>
        <p>
          제3자 계정 자체의 사유로 인해 Xiangji에 로그인할 수 없거나 구독 서비스를 정상적으로 이용할 수 없는 경우, 해당
          제3자에게 연락하여 해결해야 합니다.
        </p>
        <p>1.4 귀하는 구독 서비스 구매 시 입력하는 정보가 사실이고 정확하며 완전하도록 보장해야 합니다.</p>
        <p>귀하의 잘못된 입력, 잘못된 선택 또는 부적절한 조작으로 인해 발생한 손실은 귀하가 부담합니다.</p>
      </section>
      <section>
        <h2>3. 구독 플랜 및 요금</h2>
        <ol>
          <li>
            구독 가격
            <p>
              구독 플랜별 가격, 과금 주기 및 구체적인 혜택은 Xiangji 공식 구매 페이지에 실제 표시되는 내용을 기준으로
              합니다.
            </p>
            <p>
              Xiangji는 제품 운영 상황, 시장 변화 및 비용 변화에 따라 구독 플랜 가격을 조정할 권리가 있습니다. 다만,
              이미 구매하여 아직 유효 기간 내에 있는 구독 서비스에 대해서는 법령에 별도 규정이 있거나 쌍방이 별도로
              약정한 경우를 제외하고, 이후 가격 조정으로 인해 소급하여 조정하지 않습니다.
            </p>
          </li>
          <li>
            구독 혜택
            <p>
              이용자는 구독 플랜을 구매한 후 구독 유효 기간 내에 해당 플랜 규칙에 따라 관련 서비스를 이용할 수 있습니다.
            </p>
            <p>기능에 따라 서로 다른 과금 방식으로 계산될 수 있으며, 다음을 포함하되 이에 국한되지 않습니다:</p>
            <ul>
              <li>횟수 단위 과금;</li>
              <li>이미지 수 단위 과금;</li>
              <li>생성 작업 단위 과금;</li>
              <li>처리 시간 단위 과금;</li>
              <li>서비스 크레딧 단위 과금;</li>
              <li>플랜에 포함된 사용 횟수 또는 크레딧 단위 과금.</li>
            </ul>
            <p>
              <strong>
                구체적인 차감 기준 및 소진 규칙은 실제 이용하는 기능의 페이지에 표시된 내용을 기준으로 합니다.
              </strong>
            </p>
          </li>
          <li>
            혜택 유효 기간
            <p>구매 페이지에 별도의 설명이 없는 한, 구독 혜택은 해당 구독 기간 내에만 유효합니다.</p>
            <p>
              구독 기간이 만료된 후, 사용하지 않은 구독 크레딧, 횟수 또는 기타 임시 혜택의 이월 여부는 구체적인 플랜
              규칙을 기준으로 합니다.
            </p>
            <p>
              <strong>
                구매 페이지에 관련 크레딧의 이월이 지원되지 않는다고 명시되어 있는 경우, 사용하지 않은 크레딧은 구독
                기간 종료 후 자동으로 소멸됩니다.
              </strong>
            </p>
          </li>
          <li>
            플랜 업그레이드
            <p>
              Xiangji가 플랜 업그레이드 서비스를 제공하는 경우, 이용자는 구매 페이지에 표시된 규칙에 따라 업그레이드할
              수 있습니다.
            </p>
            <p>
              업그레이드와 관련된 차액 결제, 잔여 기간 및 혜택 계산 방식은 Xiangji 페이지에 실제 표시된 규칙을 기준으로
              합니다.
            </p>
          </li>
          <li>
            플랜 다운그레이드
            <p>
              Xiangji가 플랜 다운그레이드 서비스를 제공하는 경우, 다운그레이드 규칙은 구매 페이지에 실제 표시된 내용을
              기준으로 합니다.
            </p>
            <p>
              일부 플랜은 직접 다운그레이드를 지원하지 않을 수 있습니다. 이용자는 현재 구독 기간이 끝난 후 다른 플랜을
              다시 선택할 수 있습니다.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>4. 자동 갱신 서비스</h2>
        <p>Xiangji가 자동 갱신 기능을 제공하는 경우, 이용자는 구매 시 자동 갱신 관련 설명에 특히 유의해야 합니다.</p>
        <p>
          1. 이용자가 자동 갱신 서비스 활성화를 능동적으로 선택한 경우, 현재 구독 기간이 만료되기 전에 Xiangji는
          이용자가 선택한 갱신 주기 및 당시 적용되는 갱신 가격에 따라, 이용자가 승인한 결제 수단을 통해 다음 기간의
          구독료를 자동으로 차감할 수 있습니다.
        </p>
        <p>
          2. 자동 갱신의 구체적인 가격, 차감 시간, 갱신 주기 및 취소 방식은 이용자의 구매 및 관리 페이지에 표시된 정보를
          기준으로 합니다.
        </p>
        <p>
          3.
          <strong>
            이용자는 Xiangji 페이지에서 제공하는 방식에 따라 다음 자동 차감 전에 자동 갱신을 취소할 수 있습니다. 자동
            갱신을 취소한 후에도 이용자가 이미 구매한 현재 구독 기간은 영향을 받지 않으며, 현재 구독 기간이 끝날 때까지
            계속 이용할 수 있습니다.
          </strong>
        </p>
        <p>
          4. 결제 계정 잔액 부족, 결제 기관의 제한, 은행 카드 만료 또는 Xiangji의 귀책 사유가 아닌 기타 사유로 인해 자동
          갱신이 실패한 경우, Xiangji는 다음 구독 기간의 서비스를 계속 제공할 수 있음을 보장하지 않습니다.
        </p>
      </section>
      <section>
        <h2>5. 구독 서비스의 이용 규칙</h2>
        <ol>
          <li>
            귀하가 구매한 구독 서비스는 Xiangji 플랫폼에서 제공하는 관련 서비스에 한하여 이용할 수 있습니다.
            <p>
              Xiangji의 서면 허가 없이, 귀하는 기술적 수단, 프로그램, 스크립트 또는 기타 방식으로 Xiangji의 과금,
              크레딧, 권한 또는 접근 제어 메커니즘을 우회, 해독 또는 회피할 수 없습니다.
            </p>
          </li>
          <li>
            귀하는 Xiangji의 서비스를 이용하여 법령, 공공 질서와 선량한 풍속에 위배되거나 제3자의 정당한 권익을 침해하는
            콘텐츠를 제작, 생성, 유포 또는 처리할 수 없습니다.
            <p>다음을 포함하되 이에 국한되지 않습니다:</p>
            <ul>
              <li>불법적, 기만적 또는 허위 정보;</li>
              <li>타인의 지식재산권을 침해하는 콘텐츠;</li>
              <li>프라이버시, 초상권, 명예권 등 타인의 정당한 권익을 침해하는 콘텐츠;</li>
              <li>음란물, 폭력, 테러리즘, 극단주의 등 불법 콘텐츠;</li>
              <li>기타 법령 또는 Xiangji 플랫폼 규칙이 금지하는 콘텐츠.</li>
            </ul>
          </li>
          <li>
            귀하는 Xiangji의 서비스를 이용하여 대량 등록, 악의적 호출, 트래픽 부정, 차익 거래, 플랫폼 공격, 플랫폼의
            정상 운영 방해 또는 이와 유사한 행위를 할 수 없습니다.
          </li>
          <li>
            계정의 비정상적인 이용을 발견한 경우, 즉시 Xiangji 고객센터에 연락해 주시기 바랍니다.
            <p>귀하 자신의 사유로 인한 계정, 비밀번호 또는 결제 정보 유출로 인해 발생하는 손실은 귀하가 부담합니다.</p>
          </li>
        </ol>
      </section>
      <section>
        <h2>6. AI 서비스에 대한 특별 설명</h2>
        <ol>
          <li>
            AI 생성 결과
            <p>Xiangji의 일부 서비스는 인공지능 모델, 알고리즘 및 제3자 AI 인프라를 기반으로 제공됩니다.</p>
            <p>
              <strong>
                AI 생성에는 일정한 불확실성이 수반되므로, AI 생성 결과는 귀하의 기대와 완전히 일치하지 않을 수 있으며
                콘텐츠 오류, 문자 오류, 사실 오류, 화면 결함 또는 기타 예측할 수 없는 상황이 포함될 수 있습니다.
              </strong>
            </p>
            <p>
              AI 생성 콘텐츠를 상업 활동, 상품 출시, 광고 집행 또는 기타 용도로 사용하기 전에 필요한 수동 검토를
              진행해야 합니다.
            </p>
          </li>
          <li>
            생성 결과의 유일성 비보장
            <p>
              동일하거나 유사한 입력이 동일하거나 상이한 결과를 낳을 수 있으며, Xiangji는 생성 결과의 유일성을 보장하지
              않는다는 점을 이해하고 동의합니다.
            </p>
          </li>
          <li>
            AI 생성 콘텐츠에 대한 검토 책임
            <p>
              귀하는 Xiangji 플랫폼에 업로드한 소재 및 Xiangji를 사용하여 생성, 편집 또는 번역한 최종 콘텐츠에 대해 그에
              상응하는 책임을 부담합니다.
            </p>
            <p>
              특히 상품명, 규격, 가격, 기능, 파라미터, 인증, 효능 등 소비자 권익과 관련된 중요 정보에 대해서는 수동
              검증을 진행해야 합니다.
            </p>
          </li>
          <li>
            제3자 모델 및 서비스
            <p>
              Xiangji의 일부 AI 기능은 제3자 모델, 클라우드 컴퓨팅, 번역 서비스, 스토리지 서비스 또는 기타 기술 서비스에
              의존할 수 있습니다.
            </p>
            <p>
              제3자 서비스의 장애, 조정, 업그레이드, 제한 또는 종료로 인해 관련 기능을 일시적으로 이용할 수 없게 된
              경우, Xiangji는 합리적인 범위 내에서 대체, 복구 또는 기타 조치를 취하되, 법이 허용하는 범위 내에서 이로
              인해 발생한 간접 손실에 대해서는 책임을 지지 않습니다.
            </p>
          </li>
        </ol>
      </section>
      <section>
        <h2>7. 이용자 콘텐츠 및 지식재산권</h2>
        <ol>
          <li>
            귀하는 Xiangji 플랫폼에 업로드하는 이미지, 문자, 영상, 상품 정보 및 기타 콘텐츠가 합법적으로 승인된 것임을
            보장해야 합니다. 귀하가 업로드, 처리 또는 이용한 콘텐츠가 임의의 제3자의 지식재산권, 초상권, 프라이버시권
            또는 기타 정당한 권익을 침해하는 경우, 이로 인해 발생하는 책임은 귀하가 부담합니다.
          </li>
          <li>
            귀하가 Xiangji를 통해 업로드 또는 처리한 원본 소재의 관련 권리는 원칙적으로 계속 귀하 또는 해당 권리자에게
            귀속됩니다.
          </li>
          <li>
            귀하가 Xiangji의 서비스를 통해 생성한 콘텐츠의 관련 권리 귀속 및 이용 범위는 적용 법령 및 Xiangji의 당시
            유효한 AI 서비스 약관 또는 구체적인 제품 규칙에 따릅니다.
          </li>
          <li>
            Xiangji는 귀하가 구독 서비스를 정상적으로 이용했다는 이유로, 귀하가 업로드한 콘텐츠 중 법적으로 귀하에게
            귀속되는 지식재산권을 취득하지 않습니다. 다만, 귀하에게 서비스를 제공하고 기술 처리, 저장, 전송, 표시 및
            관련 기능을 구현하기 위하여, 귀하는 Xiangji가 서비스 제공에 필요한 범위 내에서 관련 콘텐츠를 처리하는 것에
            동의합니다.
          </li>
        </ol>
      </section>
      <section>
        <h2>8. 환불 및 구독 해지</h2>
        <ol>
          <li>
            이용자는 구독 서비스를 구매하기 전에 구매하는 플랜, 구독 기간, 가격, 혜택 및 적용 범위를 충분히 확인해야
            합니다.
          </li>
          <li>
            법령에 별도 규정이 있거나, Xiangji 페이지에 명시적으로 약속한 경우 또는 Xiangji 자신의 사유로 서비스를
            제공할 수 없게 된 경우를 제외하고,
            <strong>
              이미 사용을 시작한 구독 서비스는 원칙적으로 이용자 개인 사유에 따른 환불 또는 다른 서비스로의 교환이
              지원되지 않습니다.
            </strong>
          </li>
          <li>
            아직 사용을 시작하지 않았고 Xiangji의 환불 규칙에 부합하는 구독 주문의 경우, 이용자는 Xiangji가 공식적으로
            공지한 환불 절차에 따라 환불을 신청할 수 있습니다. 구체적인 환불 조건 및 처리 방식은 당시 유효한 Xiangji의
            환불 규칙을 기준으로 합니다.
          </li>
          <li>
            이용자가 제3자 결제 플랫폼을 통해 결제를 완료한 경우, 환불 도착 시간은 해당 결제 기관의 처리 시간에 따라
            영향을 받을 수 있습니다.
          </li>
        </ol>
      </section>
      <section>
        <h2>9. 서비스 변경, 중단 및 종료</h2>
        <ol>
          <li>
            Xiangji는 사업 발전, 기술 업그레이드, 시장 변화 및 법령 요구에 따라 구독 서비스에 대해 합리적인 조정을 할
            권리가 있으며, 다음을 포함하되 이에 국한되지 않습니다:
            <ul>
              <li>서비스 기능의 추가 또는 축소;</li>
              <li>플랜 내용 조정;</li>
              <li>서비스 크레딧 조정;</li>
              <li>과금 방식 조정;</li>
              <li>AI 모델 또는 기술 방안 조정;</li>
              <li>일부 서비스의 중단 또는 종료.</li>
            </ul>
          </li>
          <li>
            이미 구매하여 아직 유효 기간 내에 있는 구독 서비스에 대해, Xiangji가 자신의 사유로 관련 핵심 서비스의 제공을
            영구적으로 중단하는 경우, Xiangji는 구체적인 상황에 따라 합리적인 대체 방안, 기간 연장, 환불 또는 기타 처리
            방식을 제공할 것입니다.
          </li>
          <li>
            시스템 유지보수, 업그레이드, 네트워크 장애, 제3자 서비스 이상, 불가항력 또는 기타 사유로 인해 서비스가
            일시적으로 중단된 경우, Xiangji는 합리적인 노력을 다해 최대한 빨리 서비스를 복구할 것입니다.
          </li>
        </ol>
      </section>
      <section>
        <h2>10. 특별 설명 및 면책 조항</h2>
        <p>
          <strong>
            법이 허용하는 최대 범위 내에서, 다음 사유로 인해 이용자가 구독 서비스를 정상적으로 이용할 수 없게 된 경우,
            Xiangji는 이로 인해 발생한 간접 손실 또는 법률이 규정한 범위를 초과하는 책임에 대해 책임을 지지 않습니다:
          </strong>
        </p>
        <ol>
          <li>Xiangji가 공지에 따라 시스템 유지보수, 업그레이드 또는 조정을 수행하는 경우;</li>
          <li>통신 사업자, 네트워크 서비스 제공자 또는 기타 인프라의 장애;</li>
          <li>제3자 결제, 클라우드 서비스, AI 모델 또는 기타 제3자 서비스의 이상;</li>
          <li>해커 공격, 바이러스, 악성 프로그램 등 사이버 보안 사건;</li>
          <li>태풍, 지진, 홍수, 화재, 전쟁, 정부 행위 등 불가항력;</li>
          <li>이용자 자신의 기기, 네트워크, 계정 또는 조작과 관련된 사유;</li>
          <li>이용자의 본 약관 또는 기타 Xiangji 플랫폼 규칙 위반;</li>
          <li>기타 Xiangji 자신의 과실로 돌릴 수 없는 사유.</li>
        </ol>
      </section>
      <section>
        <h2>11. 계정 관리 및 위반 처리</h2>
        <ol>
          <li>
            Xiangji는 이용자가 법령, 본 약관 또는 기타 플랫폼 규칙을 위반한 사실을 발견했거나 이를 합리적으로 의심할
            만한 근거가 있는 경우, 구체적인 상황에 따라 다음을 포함하되 이에 국한되지 않는 조치를 취할 권리가 있습니다:
            <ul>
              <li>경고;</li>
              <li>일부 기능 제한;</li>
              <li>관련 서비스 중단;</li>
              <li>계정 로그인 제한;</li>
              <li>계정 중단 또는 종료;</li>
              <li>관련 불법 콘텐츠 삭제;</li>
              <li>규칙에 따라 부정하게 획득한 서비스 크레딧 차감;</li>
              <li>법에 따라 관련 부처에 보고.</li>
            </ul>
          </li>
          <li>
            이용자의 불법 또는 규정 위반 행위로 인해 Xiangji가 제3자의 청구, 행정 처벌, 사법적 책임 추궁 또는 기타
            손실을 입게 된 경우, 이용자는 법에 따라 그에 상응하는 책임을 부담합니다.
          </li>
          <li>
            이용자의 계정이 중단 또는 종료된 경우에도, 이용자는 법령 및 관련 약관에 따라 이미 발생한 책임을 계속
            부담합니다.
          </li>
        </ol>
      </section>
      <section>
        <h2>12. 거래 이상 및 시스템 장애</h2>
        <ol>
          <li>
            Xiangji 시스템 장애로 인해 이용자가 실제 구매한 구독 혜택이 주문 기록과 일치하지 않게 된 경우, 이용자는
            고객센터 채널을 통해 관련 결제 증빙 및 주문 정보를 제공할 수 있습니다. Xiangji의 확인 후, Xiangji는 실제
            상황에 따라 혜택 보충, 주문 정정 또는 기타 합리적인 처리 조치를 취할 것입니다.
          </li>
          <li>
            시스템 장애로 인해 이용자가 실제 결제 금액에 상응하는 범위를 초과하는 구독 혜택을 획득하게 된 경우,
            Xiangji는 해당 이상 혜택을 정정하거나 회수할 권리가 있습니다.
          </li>
          <li>
            이용자가 시스템 취약점, 기술적 수단 또는 기타 방식을 이용하여 이상 구독 혜택을 획득한 것으로 확인된 경우,
            Xiangji는 관련 이상 혜택을 취소할 권리가 있으며, 상황에 따라 추가 조치를 취할 수 있습니다.
          </li>
        </ol>
      </section>
      <section>
        <h2>13. 약관의 변경</h2>
        <p>Xiangji는 법령, 사업 발전 및 서비스 변화에 따라 본 약관을 수정할 권리가 있습니다.</p>
        <p>
          약관에 중대한 변경이 발생한 경우, Xiangji는 웹사이트 공지, 제품 페이지, 사이트 내 알림 또는 기타 합리적인
          방식으로 이용자에게 고지할 것입니다.
        </p>
        <p>
          <strong>
            수정된 약관에 동의하지 않으시는 경우, 관련 구독 서비스의 이용을 중단하실 수 있습니다. 구독 서비스를 계속
            구매하거나 이용하는 경우, 수정된 약관을 수락한 것으로 간주됩니다.
          </strong>
        </p>
        <p>업데이트된 약관은 게시일 또는 약정된 시행일부터 효력이 발생합니다.</p>
      </section>
      <section>
        <h2>14. Xiangji에 문의</h2>
        <p>
          본 약관, 구독 서비스, 주문, 환불 또는 기타 관련 문제에 대해 궁금한 점이 있는 경우, 다음 방식으로 Xiangji에
          문의하실 수 있습니다:
        </p>
        <ul>
          <li>
            공식 웹사이트:
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>온라인 고객센터: Xiangji 제품 내 온라인 고객센터</li>
          <li>고객센터 이메일: 510807298@qq.com</li>
          <li>회사명: 쑤저우 Xiangji 테크놀로지 서비스 유한공사</li>
          <li>
            회사 주소: <strong>상하이시 푸동신구 나셴로 800호 커하이 빌딩</strong>
          </li>
        </ul>
        <p>Xiangji는 귀하의 문의, 불만 또는 의견을 접수한 후 합리적인 기간 내에 처리할 것입니다.</p>
      </section>
      <section>
        <h2>15. 준거법 및 분쟁 해결</h2>
        <ol>
          <li>본 약관의 체결, 효력 발생, 이행, 해석 및 분쟁 해결은 모두 중화인민공화국 법률의 적용을 받습니다.</li>
          <li>
            본 약관 또는 구독 서비스와 관련하여 분쟁이 발생한 경우, 쌍방은 먼저 우호적인 협상을 통해 해결해야 합니다.
          </li>
          <li>
            협상이 결렬된 경우, 쌍방은 분쟁을 <strong>Xiangji의 실제 운영 주체 소재지를 관할하는 인민법원</strong>에
            제출하여 해결하기로 동의합니다.
          </li>
          <li>
            본 약관의 어떤 조항이 현행 법령과 충돌하여 무효 또는 집행 불가능한 것으로 판단되더라도, 본 약관의 기타
            조항의 효력에는 영향을 미치지 않습니다.
          </li>
        </ol>
      </section>
      <section>
        <h2>16. 약관의 효력 발생</h2>
        <p>
          "동의 후 구매", "구매 확인", "지금 결제" 또는 기타 유사한 의미를 가진 버튼을 클릭하거나, 실제로 구독료를
          결제하고 구독 서비스 이용을 시작하는 경우, 본 약관의 전체 내용을 읽고 이해했으며 동의한 것으로 간주됩니다.
        </p>
        <p>
          <strong>
            본 약관은 귀하가 구독 서비스 구매를 완료한 날부터 효력이 발생하며, 귀하가 구독 서비스를 이용하는 기간 동안
            계속 유효합니다.
          </strong>
        </p>
      </section>
    </>
  );
};

export default KoContent;
